import React, { useMemo } from 'react';

import { Text } from '@mantine/core';
import { CellProps, Column } from 'react-table';
import { WorkoutTemplateList } from 'types';

import ActionsCell from '../components/ActionsCell';
import TemplateNameCell from '../components/TemplateNameCell';

export interface WorkoutTemplatesColumnsInput {
  permission: boolean;
  handlePreview: (template: WorkoutTemplateList) => void;
  handleEdit: (template: WorkoutTemplateList) => void;
  handleDuplicate: (template: WorkoutTemplateList) => void;
  handleDelete: (template: WorkoutTemplateList) => void;
}

export function useWorkoutTemplatesColumns(
  input: WorkoutTemplatesColumnsInput,
): Column<WorkoutTemplateList>[] {
  const { permission, handlePreview, handleEdit, handleDuplicate, handleDelete } = input;

  return useMemo(
    (): Column<WorkoutTemplateList>[] => [
      {
        Header: 'Workout Template Name',
        accessor: 'name' as const,
        Cell: ({ row }: CellProps<WorkoutTemplateList>) => (
          <TemplateNameCell template={row.original} onPreview={handlePreview} />
        ),
      },
      {
        Header: 'Scoring',
        id: 'scoring',
        Cell: () => <Text>-</Text>,
      },
      {
        Header: 'Actions',
        id: 'action',
        Cell: ({ row }: CellProps<WorkoutTemplateList>) => (
          <ActionsCell
            template={row.original}
            permission={permission}
            onPreview={handlePreview}
            onEdit={handleEdit}
            onDuplicate={handleDuplicate}
            onDelete={handleDelete}
          />
        ),
        minWidth: 3.125,
        maxWidth: 3.125,
      },
    ],
    [permission, handlePreview, handleEdit, handleDuplicate, handleDelete],
  );
}
